import useInterval from '@use-it/interval';
import cx from 'classnames';
import { Toast } from 'components/Modal';
import apiClient from 'modules/apiClient';
import { history } from 'modules/navigator';
import useTitle from 'modules/useTitle';
import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';

export default function Withdraw() {
  useTitle('提现至微信账户');
  const [toastVisible, setToastVisible] = useState(false);
  const [message, setMessage] = useState('');
  const [name, setName] = useState('');
  const [code, setCode] = useState('');
  const [phone, setPhone] = useState('');
  const [payment, setPayment] = useState({ id: undefined, phone: '' });
  const [inviteAward, setInviteAward] = useState({ count: 0, money: 0 });
  const [codeSenderEnable, setCodeSenderEnable] = useState(true);
  const [codeSenderCD, setCodeSenderCD] = useState(60);

  useInterval(
    () => {
      if (codeSenderCD <= 0) {
        setCodeSenderEnable(true);

        return;
      }

      setCodeSenderCD(codeSenderCD - 1);
    },
    !codeSenderEnable ? 1000 : null
  );

  function showToast(newMessage: string) {
    setMessage(newMessage);
    setToastVisible(true);

    setTimeout(() => {
      setToastVisible(false);
    }, 2000);
  }

  async function fetchInviteAward() {
    const response = await apiClient.invite.award();
    if (response.status !== 10000) {
      showToast(response.msg);

      return;
    }

    setInviteAward(response.body);
  }

  async function sendCode() {
    if (!codeSenderEnable) {
      return;
    }

    if (!phone) {
      showToast('请填写手机号');

      return;
    }

    const response = await apiClient.base.sendCode({
      phone
    });

    if (response.status !== 10000) {
      showToast(response.msg);

      return;
    }

    showToast('验证码已发送');

    setCodeSenderEnable(false);
    setCodeSenderCD(60);
  }

  async function getPayment() {
    const response = await apiClient.base.getPayment({ type: 'wxpay' });

    if (response.status !== 10000) {
      return;
    }

    setPhone(response.body.code);
    setPayment({
      id: response.body.id,
      phone: response.body.code
    });
  }

  function isPaymentExist() {
    return phone && phone === payment.phone;
  }

  useEffect(() => {
    fetchInviteAward();
    getPayment();
  }, []);

  function handlePhoneChange(event: React.ChangeEvent<HTMLInputElement>) {
    setPhone(event.target.value);
  }

  function handleNameChange(event: React.ChangeEvent<HTMLInputElement>) {
    setName(event.target.value);
  }

  function handleCodeChange(event: React.ChangeEvent<HTMLInputElement>) {
    setCode(event.target.value);
  }

  async function handleWithdraw() {
    let paymentId = payment.id;

    // 还没有绑定过就要先添加支付方式
    if (!paymentId) {
      const { status, body, msg } = await apiClient.base.addPay({
        code: phone,
        name,
        type: 'wxpay'
      });

      if (status !== 10000) {
        showToast(msg);
        return;
      }

      setPayment({
        id: body.id,
        phone
      });

      paymentId = body.id;
    }

    const response = await apiClient.base.withdraw({
      id: paymentId,
      money: Number(inviteAward.money)
    });

    if (response.status !== 10000) {
      showToast(response.msg);

      return;
    }

    history.push('/withdraw/success');
  }

  async function handleSubmit() {
    if (!name) {
      showToast('请填写真实姓名');
      return;
    }
    if (!phone) {
      showToast('请填写微信绑定的手机号码');
      return;
    }

    if (!isPaymentExist() && !code) {
      showToast('请填写手机验证码');
      return;
    }

    if (!isPaymentExist()) {
      await apiClient.base.validateCode({
        phone,
        vcode: code
      });
    }

    handleWithdraw();
  }

  return (
    <div className={styles.container}>
      <Toast isOpen={toastVisible} message={message} />
      <div className={styles.hint}>
        <span>提醒：</span>
        <span>1、申请提现后1个工作日内发放至您的微信账户</span>
        <span>2、提现微信号与您当前登录微信号必须一致</span>
      </div>
      <div className={styles.title}>
        可提现金额： <span className={styles.amount}>{inviteAward.money}</span>
        &nbsp;元
      </div>
      <div className={styles.form}>
        <input
          value={name}
          onChange={handleNameChange}
          className={styles.input}
          placeholder="请输入您的真实姓名"
        />
        <input
          value={phone}
          onChange={handlePhoneChange}
          className={styles.input}
          placeholder="请输入微信绑定的手机号"
        />
        {!isPaymentExist() && (
          <div className={styles.codeInput}>
            <input
              value={code}
              onChange={handleCodeChange}
              className={styles.input}
              placeholder="请输入手机验证码"
            />
            <div
              className={cx(
                styles.codeButton,
                codeSenderEnable ? '' : styles.disabled
              )}
              onClick={sendCode}
            >
              获取验证码 {codeSenderEnable ? '' : '(' + codeSenderCD + ')'}
            </div>
          </div>
        )}
      </div>
      <div onClick={handleSubmit} className={styles.button}>
        申请提现{inviteAward.money}元
      </div>
    </div>
  );
}
